<template>
  <div>
    <!-- job details -->
    <Modal :config="jobDetailsModalConfig">
      <template slot="header">
          Job detaljer
      </template>
      <template slot="content">
          <div class="form">
            <div class="grid-x align-items">
              <div class="large-1 medium-1 small-2 cell flexbox-center">
                <icon class="info small-svg" name="routinecalendar"></icon>
              </div>
              <div class="auto cell border-bottom">
                <div class="grid-x">
                  <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                    <label for="remark">Dato</label>
                  </div>
                  <div class="auto cell flexbox-center-left">
                    <p>{{ selectedJob.opdateretDato | formatDateWithTime }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form">
          <div class="grid-x align-items">
            <div class="large-1 medium-1 small-2 cell flexbox-center">
              <icon class="info small-svg" name="info"></icon>
            </div>
            <div class="auto cell border-bottom border-bottom-last">
              <div class="grid-x">
                <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                  <label for="remark">Bemærkning</label>
                </div>
                <div class="auto cell">
                  <p>{{ selectedJob.bemaerkning }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal :config="jobRemoveModalConfig" @accept="removeJob()">
      <template slot="header">
          Slet job
      </template>
      <template slot="content">
        <div class="modal-body">
          <p class="text-center">Er du sikker på, at du vil slette jobbet?</p>
          <p class="text-center">Dette kan ikke fortrydes.</p>
        </div>
      </template>
    </Modal>

    <div class="auto cell" style="margin-top: 15px;"></div> <!-- Dummy: for keep layout -->

    <!-- jobs counter -->
    <div class="grid-x list-counter">
        <div v-if="jobs.length > 0" class="flexbox-align-items">
            <span>{{jobs.length}} job<span v-if="jobs.length > 1">s</span></span>
        </div>
        <div v-else class="large-12 no-result">
            <div class="grid-x">
                <div class="large-12 cell">
                    <span>Ingen jobs</span>
                </div>
            </div>
            <div class="grid-x">
                <div class="large-12 no-result-img cell"></div>
            </div>
        </div>
    </div>

    <!-- jobs sort -->
    <div v-if="jobs.length > 0" class="grid-x list-sort">
        <div class="large-3 cell item flexbox no-margin" @click="sort('opdateretDato')" :class="{selected: currentSort === 'opdateretDato'}" style="padding-left: 16px;">
            <span>Dato</span>
            <div>
                <icon v-if="currentSort === 'opdateretDato'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'opdateretDato'}" name="keyboard_arrow_sort"></icon>
            </div>
        </div>
        <div class="large-2 cell item flexbox no-margin" @click="sort('jobStatusKode')" :class="{selected: currentSort === 'jobStatusKode'}">
            <span>Job status</span>
            <div>
                <icon v-if="currentSort === 'jobStatusKode'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'jobStatusKode'}" name="keyboard_arrow_sort"></icon>
            </div>
        </div>
        <div class="large-2 cell item flexbox no-margin" @click="sort('jobTypeKode')" :class="{selected: currentSort === 'jobTypeKode'}">
            <span>Job type</span>
            <div>
                <icon v-if="currentSort === 'jobTypeKode'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'jobTypeKode'}" name="keyboard_arrow_sort"></icon>
            </div>
        </div>
        <div class="auto cell item flexbox non-sortable">
            <span>bemaerkning</span>
        </div>
    </div>

    <!-- jobs list -->
    <transition-group name="list" tag="div">
        <div v-for="job in sortedJobs" :key="job.id" class="cursor">
            <div class="grid-x list-row entity-icon-row align-items">
                <div @click="openJobDetails(job)" class="large-3 cell item truncate-fade flexbox-align-items">
                    <span>{{ job.opdateretDato | formatDateWithTime }}</span>
                </div>
                <div @click="openJobDetails(job)" class="large-2 cell item truncate-fade flexbox-align-items">
                    <span>{{ getJobStatus(job.jobStatusKode) }}</span>
                </div>
                <div @click="openJobDetails(job)" class="large-2 cell item truncate-fade flexbox-align-items">
                    <span :title="getJobType(job.jobTypeKode)">{{ getJobType(job.jobTypeKode) }}</span>
                </div>
                <div @click="openJobDetails(job)" class="auto cell item truncate-fade flexbox-align-items">
                    <span>{{ job.bemaerkning }}</span>
                </div>
                <div v-if="job.jobStatusKode === 1" class="large-1 cell item flexbox-center">
                    <div @click="openRemoveJob(job)" class="button-list-with-icon cursor">
                        <icon class="medium-svg fill-white" name="delete"></icon>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>

    <paginate :records="jobs.length" v-model="sortedJobs" :page-size="perPage" :changePage="changePage" :showPaging="false" :position="'left'" :selectedTab="selectedTab" :activePage="currentPage"></paginate>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/store/api.js'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'
import paginate from '@/components/paginate/paginate.vue'

export default {
    name: 'dashboard-jobs-list',
    components: {
        Modal,
        paginate
    },
    props: {
        value: Array,
        selectedTab: String
    },
    data () {
        return {
            jobs: this.value,
            currentPage: 1,
            perPage: 10,
            currentSortDir: 'desc',
            currentSort: 'opdateretDato',
            jobDetailsModalConfig: null,
            jobRemoveModalConfig: null,
            selectedJob: {}
        }
    },
    computed: {
        ...mapGetters({
            codeLists: 'getCodelists'
        }),
        sortedJobs () {
            let sortedArray = this.jobs.slice(0).sort((a, b) => {
                let modifier = 1
                if (this.currentSortDir === 'desc') {
                    modifier = -1
                }
                if (a[this.currentSort] < b[this.currentSort] || a[this.currentSort] === null) {
                    return -1 * modifier
                }
                if (a[this.currentSort] > b[this.currentSort] || b[this.currentSort] === null) {
                    return 1 * modifier
                }
                return 0
            })

            let groups = []

            // eslint-disable-next-line
        while (sortedArray && sortedArray.length > 0) {
                groups.push(sortedArray.splice(0, this.perPage))
            }
            return groups[this.currentPage - 1]
        }
    },
    methods: {
        changePage (page) {
            this.currentPage = page
        },
        sort (s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = s
        },
        getJobStatus (statusKode) {
            if (statusKode) {
                return this.codeLists.jobStatus.find(s => s.kode === statusKode).beskrivelse
            }
        },
        getJobType (typeKode) {
            if (typeKode) {
                return this.codeLists.jobType.find(t => t.kode === typeKode).beskrivelse
            }
        },
        openJobDetails (job) {
            this.selectedJob = job
            this.jobDetailsModalConfig.open()
        },
        openRemoveJob (job) {
            this.selectedJob = job
            this.jobRemoveModalConfig.open()
        },
        async removeJob () {
            try {
                const response = await axios.post('/Value/Job/DeleteJob', {
                    id: this.selectedJob.id
                })
                if (response) {
                    this.$emit('updateJobList', this.selectedJob)
                }
            } catch (err) {
                console.log('error remove job', err)
            }
        }
    },
    watch: {
        value (jobs) {
            this.jobs = jobs
        }
    },
    created () {
        this.jobDetailsModalConfig = new ModalConfig({
            reject: 'Luk vindue'
        })
        this.jobRemoveModalConfig = new ModalConfig({
            reject: 'Annuller',
            accept: 'Slet job'
        })
    }
}
</script>

<style lang="scss" scoped>
.form {
  .border-bottom {
    border-bottom: 1px solid #efeded;
    padding-top: 15px;
    padding-bottom: 15px;
    position: relative;

    p {
      margin-bottom: 0px;
    }
  }

  .border-bottom-last {
    border-bottom: 0px !important;
  }
}

.list-sort .non-sortable {
    cursor: initial;

    &:hover, &:focus, &:active {
        text-decoration: none;
    }
}

.modal-body p {
    margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/dashboard/dashboard-jobs-list.vue